<script setup>
</script>
<template>
    <section class="edit-btn-container">
        <img v-if="!isCreating" src="@/assets/atualizar.png" :title="$t('limpar')" :alt="$t('limpar')" @click="clearFunc"/>
        <button v-if="isCreating" @click.prevent="handleTab" :disabled="!enableCommit">Desbloquear {{ nextTabName }} 🔓</button>
        <img v-else src="@/assets/salvar.png" :alt="$t('salvar')" :title="$t('salvar')"
            @click="saveFunc" :class="enableCommit == true ? '' : 'disabled-grayscale'"/>
    </section>
</template>
<script>
import MediatorIndicatorEditor from '../MediatorIndicatorEditor';
export default {
    name: 'SaveButtons',
    props: {
        isCreating: Boolean,
        allowTab: Function,
        tabToEnable: String,
        nextTabName: String,
        enableCommit: Boolean,
        saveFunc: Function,
        clearFunc: Function,
        creationToKeep: Object,
    },
    methods:{
        handleTab(){
            if(this.isCreating == true){
                let type = this.creationToKeep.type;

                if(MediatorIndicatorEditor[type] != undefined){
                    MediatorIndicatorEditor[type] = this.creationToKeep
                }
            }

            this.allowTab(this.tabToEnable);
        }
    }
}
</script>
<style scoped>
.edit-btn-container {
    position: absolute;
    display: block;
    top: auto;
    right: 10px;
}

img {
    cursor: pointer;
    max-height: 35px;
    margin-left: 1rem;
}

button {
    background: transparent;
    border: none;
    color: #FF5F00;
    cursor: pointer;
}

button[disabled="disabled"] {
    filter: grayscale(1);
    cursor: not-allowed;
}

.disabled-grayscale{
    cursor: not-allowed;
    pointer-events: none;
    filter: grayscale(1);
}
</style>